/**
 * Detect whether the app is running inside an iframe (e.g. Wix dashboard).
 */
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin iframes throw on accessing window.top
    return true;
  }
};

/**
 * Navigate to an external URL.
 *
 * When the portal is rendered inside an iframe (e.g. the Wix dashboard),
 * services like Stripe Checkout refuse to load inside the frame.
 * In that case we redirect the **top-level** window so the page loads
 * outside the iframe. For non-iframe contexts nothing changes — the
 * redirect behaves exactly as before.
 */
export const navigateExternal = (url) => {
  if (isInIframe()) {
    window.top.location.href = url;
  } else {
    window.location.href = url;
  }
};
